import { postRequestJson } from "../utils/request"

const baseUrl = 'http://192.168.1.184:8888'

export function login(params){
  return postRequestJson('/jundaWebSite/login', params, baseUrl)
}